// extracted by mini-css-extract-plugin
export default {"icon":"IconButton--icon--_c8qYM_s","shareButton":"IconButton--shareButton--pBIwixic","shareIcon":"IconButton--shareIcon--rNbbcZDW"};